export default __webpack_public_path__ + "static/media/iot.51fb657d.jpg";